document.addEventListener('DOMContentLoaded', function() {
  // Mobile Search Toggle
  const mobileSearchToggle = document.querySelector('.mobile-search-toggle');
  const mobileSearchOverlay = document.getElementById('mobile-search-overlay');
  
  if (mobileSearchToggle && mobileSearchOverlay) {
    mobileSearchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      openMobileSearchOverlay();
    });
  }

  // Open mobile search overlay
  function openMobileSearchOverlay() {
    if (mobileSearchOverlay) {
      mobileSearchOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      
      // Focus on search input when overlay opens
      const searchInput = mobileSearchOverlay.querySelector('.mobile-search-input');
      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 300);
      }
    }
  }

  // Close mobile search overlay
  function closeMobileSearchOverlay() {
    if (mobileSearchOverlay) {
      mobileSearchOverlay.classList.remove('active');
      document.body.style.overflow = '';
      
      // Reset search state
      resetMobileSearch();
    }
  }

  // Make function globally available
  window.closeMobileSearchOverlay = closeMobileSearchOverlay;

  // Close overlay on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileSearchOverlay.classList.contains('active')) {
      closeMobileSearchOverlay();
    }
  });

  // Mobile Search Functionality
  const mobileSearchInput = document.querySelector('.mobile-search-overlay .mobile-search-input');
  const searchResults = document.querySelector('.mobile-search-overlay .search-results');
  const loadingState = document.querySelector('.mobile-search-overlay .predictive-search__loading-state');
  const resultsContainer = document.querySelector('.mobile-search-overlay .predictive-search__results');

  if (mobileSearchInput) {
    // Search input event handler
    mobileSearchInput.addEventListener('input', debounce((event) => {
      const searchTerm = event.target.value.trim();
      
      if (searchTerm.length > 0) {
        showMobileSearchResults();
        showMobileLoading();
        performMobileSearch(searchTerm);
      } else {
        hideMobileSearchResults();
      }
    }, 300));

    // Form submit handler
    mobileSearchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        const searchTerm = this.value.trim();
        if (searchTerm.length > 0) {
          // Navigate to search results page
          window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
        }
      }
    });
  }

  function showMobileSearchResults() {
    if (searchResults) {
      searchResults.classList.add('active');
    }
  }

  function hideMobileSearchResults() {
    if (searchResults) {
      searchResults.classList.remove('active');
    }
  }

  function resetMobileSearch() {
    if (mobileSearchInput) {
      mobileSearchInput.value = '';
    }
    hideMobileSearchResults();
    hideMobileLoading();
  }

  function showMobileLoading() {
    if (loadingState && resultsContainer) {
      loadingState.style.display = 'flex';
      resultsContainer.style.display = 'none';
    }
  }

  function hideMobileLoading() {
    if (loadingState && resultsContainer) {
      loadingState.style.display = 'none';
      resultsContainer.style.display = 'block';
    }
  }

  function performMobileSearch(searchTerm) {
    // Basit arama URL'i oluştur
    const searchUrl = `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&resources[options][limit]=10`;
    
    fetch(searchUrl)
      .then(response => response.json())
      .then(suggestions => {
        hideMobileLoading();
        
        const products = suggestions.resources.results.products || [];
        displayMobileSearchResults(products, searchTerm);
      })
      .catch(error => {
        console.error('Error fetching mobile search results:', error);
        hideMobileLoading();
        displayMobileSearchResults([], searchTerm);
      });
  }

  function displayMobileSearchResults(results, searchTerm) {
    if (!resultsContainer) return;
    
    // Çeviri anahtarlarını al
    const translations = window.searchTranslations || {};
    
    if (!results || results.length === 0) {
      resultsContainer.innerHTML = `
        <div class="predictive-search__no-results">
          <p>"${searchTerm}" için ürün bulunamadı</p>
          <div class="predictive-search__suggestions">
            <strong>Öneriler:</strong>
            <ul>
              <li>Farklı anahtar kelimeler deneyin</li>
              <li>Daha genel terimler kullanın</li>
              <li>Yazım hatası olup olmadığını kontrol edin</li>
            </ul>
          </div>
        </div>
      `;
    } else {
      resultsContainer.innerHTML = `
        <div class="predictive-search__results-header">
          <h3>"${searchTerm}" için ${results.length} sonuç bulundu</h3>
        </div>
        <div class="predictive-search__results-list">
          ${results.map(product => `
            <a href="${product.url}" class="predictive-search__item" onclick="closeMobileSearchOverlay()">
              <div class="predictive-search__item-image-wrapper">
                <img src="${product.image || product.featured_image}" alt="${product.title}" class="predictive-search__item-image">
                ${product.available === false ? '<span class="out-of-stock-badge">Tükendi</span>' : ''}
              </div>
              <div class="predictive-search__item-info">
                <h4 class="predictive-search__item-title">${product.title}</h4>
                ${product.vendor ? `<p class="predictive-search__item-vendor">${product.vendor}</p>` : ''}
                <div class="predictive-search__item-price">
                  ${formatMobilePrice(product)}
                </div>
              </div>
            </a>
          `).join('')}
        </div>
        <div class="predictive-search__view-all">
          <a href="/search?q=${encodeURIComponent(searchTerm)}" class="view-all-btn">
            Daha fazla göster (${results.length})
          </a>
        </div>
      `;
    }
  }

  // Format price for mobile display
  function formatMobilePrice(product) {
    const price = parseFloat(product.price);
    const compareAtPrice = product.compare_at_price ? parseFloat(product.compare_at_price) : null;
    
    if (compareAtPrice && compareAtPrice > price) {
      return `
        <span class="compare-at-price">${(compareAtPrice / 100).toLocaleString('tr-TR', {style: 'currency', currency: 'TRY'})}</span>
        <span class="final-price">${(price / 100).toLocaleString('tr-TR', {style: 'currency', currency: 'TRY'})}</span>
      `;
    }
    return `<span class="final-price">${(price / 100).toLocaleString('tr-TR', {style: 'currency', currency: 'TRY'})}</span>`;
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Mobile Menu Toggle
  const menuButton = document.querySelector('.menu-button');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuOverlay = document.querySelector('.menu-overlay');
  const closeMenuButtons = document.querySelectorAll('.close-menu-2');
  
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', function() {
      mobileMenu.classList.add('active');
      menuOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
    
    // Close menu functions
    function closeMenu() {
      mobileMenu.classList.remove('active');
      menuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
    
    // Close menu on overlay click
    if (menuOverlay) {
      menuOverlay.addEventListener('click', closeMenu);
    }
    
    // Close menu on close button click
    closeMenuButtons.forEach(button => {
      button.addEventListener('click', closeMenu);
    });
    
    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
        closeMenu();
      }
    });
  }
  
  // Tab Switching
  const tabItems = document.querySelectorAll('.tab-item');
  const tabContents = document.querySelectorAll('.tab-content');
  
  // Tab click functionality - set active tab when clicked
  function setActiveTab(tabElement) {
    const targetTab = tabElement.getAttribute('data-tab');
    
    // Remove active class from all tabs and contents
    tabItems.forEach(t => t.classList.remove('active'));
    tabContents.forEach(c => c.classList.remove('active'));
    
    // Add active class to clicked tab and corresponding content
    tabElement.classList.add('active');
    const targetContent = document.querySelector(`[data-content="${targetTab}"]`);
    if (targetContent) {
      targetContent.classList.add('active');
    }
  }
  
  // Tab click functionality
  tabItems.forEach(tab => {
    tab.addEventListener('click', function(e) {
      // Set this tab as active
      setActiveTab(this);
    });
  });
  
  // Mega Menu Toggle
  const megaMenuTriggers = document.querySelectorAll('.mega-menu-trigger-mobile');
  
  megaMenuTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      const targetMenu = document.getElementById(targetId);
      const arrow = this.querySelector('.trigger-arrow');
      
      if (targetMenu) {
        const isActive = targetMenu.classList.contains('active');
        
        // Close all other mega menus
        document.querySelectorAll('.mobile-mega-menu').forEach(menu => {
          menu.classList.remove('active');
        });
        
        // Reset all arrows
        document.querySelectorAll('.trigger-arrow').forEach(arr => {
          arr.style.transform = 'rotate(0deg)';
        });
        
        if (!isActive) {
          targetMenu.classList.add('active');
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
          }
        }
      }
    });
  });
  
  // Submenu Toggle
  const submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
  
  submenuToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const targetId = this.getAttribute('data-submenu-toggle');
      const targetSublist = document.querySelector(`[data-submenu-content="${targetId}"]`);
      const arrow = this.querySelector('.submenu-arrow');
      
      if (targetSublist) {
        const isActive = targetSublist.classList.contains('active');
        
        if (isActive) {
          targetSublist.classList.remove('active');
          if (arrow) {
            arrow.style.transform = 'rotate(0deg)';
          }
        } else {
          targetSublist.classList.add('active');
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
          }
        }
      }
    });
  });
  
  // Mobile Submenu Toggle
  const mobileSubmenuToggles = document.querySelectorAll('[data-submenu]');
  
  mobileSubmenuToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const targetId = this.getAttribute('data-submenu');
      const targetList = document.querySelector(`[data-submenu-content="${targetId}"]`);
      const arrow = this.querySelector('.mobile-submenu-arrow');
      
      if (targetList) {
        const isActive = targetList.classList.contains('active');
        
        if (isActive) {
          targetList.classList.remove('active');
          if (arrow) {
            arrow.style.transform = 'rotate(0deg)';
          }
        } else {
          targetList.classList.add('active');
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
          }
        }
      }
    });
  });
  
  // Language Selector
  const languageSelectorButton = document.querySelector('.language-selector-button');
  const languageDropdown = document.querySelector('.language-dropdown');
  const languageArrow = document.querySelector('.language-arrow');
  
  if (languageSelectorButton && languageDropdown) {
    languageSelectorButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        this.setAttribute('aria-expanded', 'false');
        languageDropdown.hidden = true;
        if (languageArrow) {
          languageArrow.style.transform = 'rotate(0deg)';
        }
      } else {
        this.setAttribute('aria-expanded', 'true');
        languageDropdown.hidden = false;
        if (languageArrow) {
          languageArrow.style.transform = 'rotate(180deg)';
        }
      }
    });
    
    // Close language dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!languageSelectorButton.contains(e.target) && !languageDropdown.contains(e.target)) {
        languageSelectorButton.setAttribute('aria-expanded', 'false');
        languageDropdown.hidden = true;
        if (languageArrow) {
          languageArrow.style.transform = 'rotate(0deg)';
        }
      }
    });
  }
}); 